function onChangeQtyVal(productId) {
  var product_current_price = document.getElementById("product_current_price_"+productId).innerHTML;
  var curent_symbol = document.getElementById("curent_symbol_"+productId).value;
  var newPrice = product_current_price.replace(curent_symbol, '');
  var selectQuantity = document.getElementById("quantity_sel_"+productId).value;
  
  var newPrice1 = newPrice * selectQuantity;
  //alert(product_current_price+"===="+curent_symbol+"===="+newPrice+"===="+selectQuantity+"===="+newPrice1);
  document.getElementById("add-cart-price-"+productId).innerHTML = curent_symbol+newPrice1;
}
